import { DispatcherEvent } from '@carvana/merch-native';
import sendMessageToNative from '~/native/srp/dispatchers/sendMessageToNative';

export default function sendFavoriteMessageToNative(
  action: 'add' | 'remove',
  payload: { vehicleId: number }
) {
  sendMessageToNative(
    action === 'add'
      ? DispatcherEvent.FavoriteAdded
      : DispatcherEvent.FavoriteRemoved,
    payload
  );
}
